<template>
    <span v-if="mostrarIcone">
        <span class="text-primary ml-1">
            <i
                class="fa fa-info-circle fa-lg icon-button"
                :title="`Justificativa ${textoIcone}`"
                @click.stop="mostrarDetalhe()"
            ></i>
        </span>
        <b-modal id="modalDetalhe" v-model="mostrarModalDetalhe">
            <div slot="modal-title">Justificativa {{textoIcone}}</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            :disabled="true"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharDetalhe()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import { StatusDespesa } from './StatusDespesa'

export default {
    props: {
        despesa: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalDetalhe: false,
            mensagem: ''
        }
    },

    methods: {
        mostrarDetalhe() {
            this.mostrarModalDetalhe = true
        },

        fecharDetalhe() {
            this.mostrarModalDetalhe = false
        }
    },

    computed: {
        mostrarIcone() {
            return this.despesa.statusId == StatusDespesa.REPROVADA_POR_DEMANDANTE 
                || this.despesa.statusId == StatusDespesa.REPROVADA_POR_GERENTE
                || this.despesa.statusId == StatusDespesa.REPROVADA_PELA_UABS
                || this.despesa.statusId == StatusDespesa.CANCELADA
        },

        textoIcone() {
            return this.despesa.statusId == StatusDespesa.CANCELADA ? 'do Cancelamento' : 'da Reprovaçaão'
        },

        justificativa() {
            return this.despesa.statusId == StatusDespesa.CANCELADA ? this.despesa.justificativaCancelamento : this.despesa.justificativaReprovacao
        }
    }
}
</script>
